import { i18n as Ii18, TFunction } from 'i18next';

export class I18NextStore {
  readonly t: TFunction;

  constructor(i18: Ii18) {
    this.t = i18.t;
  }
}
